import React from 'react';
import { components } from 'react-select';

export const ReactSelectClearIndicator = props => (
	<components.ClearIndicator {...props}>
		<img
			src="/ats/icons/clear-select-icon.svg"
			alt=""
			className="react-select-clear-icon"
			width={16}
			height={16}
		/>
	</components.ClearIndicator>
);

export const reactSelectAtsComponents = {
	IndicatorSeparator: () => null,
	DropdownIndicator: () => (
		<img src="/ats/icons/chevron-down-icon.svg" alt="" width={18} height={18} />
	),
	ClearIndicator: ReactSelectClearIndicator
};
